module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// /~/react-lazy-cache/noGetters.js
// module id = dyGX
// module chunks = 0